import { defineMessages } from 'utils/intl';

export default defineMessages({
  freeStationary: 'Szkolenie bezpłatne',
  freeRemote: 'Webinar bezpłatny',
  privateConference: 'Zaproszenie indywidualne',
});
